export default "__VITE_ASSET__CSIQ5ZBt__"